import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { errorHandlingInterceptor } from './core/interceptors/error-handling.interceptor';
import { tenantInterceptor } from './core/interceptors/tenant.interceptor';
import { csrfInterceptor } from './core/interceptors/csrf.interceptor';
import { tenantBaseHref } from './core/utils/tenant-path.util';
import { routes } from './app.routes';

/**
 * Path-based tenancy. Under /w/<slug>/... the router base href becomes
 * /w/<slug>/ so every existing route/link works unchanged while the address bar
 * keeps the workspace prefix. Assets still resolve from <base href> in
 * index.html because APP_BASE_HREF only steers the router, not the DOM.
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: APP_BASE_HREF, useFactory: () => tenantBaseHref() },
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
    provideHttpClient(withInterceptors([csrfInterceptor, tenantInterceptor, errorHandlingInterceptor])),
  ],
};
